import { Group as TweenGroup } from '@tweenjs/tween.js';

// Global tween group for managing all animations
export const tweenGroup = new TweenGroup();
